"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.testHttpHeaderEnumValidity = testHttpHeaderEnumValidity;
function testHttpHeaderEnumValidity(testEnum) { }
